import { Link, NavLink } from "react-router-dom"
import { useAtom } from "jotai"
import { isSuperAdminAtom } from "../../state"

const AdminNav = () => {
  const [isSuperAdmin] = useAtom(isSuperAdminAtom)

  const navLinkClasses = ({ isActive }) =>
    `text-sm font-medium py-4 border-b-2 transition-colors ${
      isActive
        ? "text-brand border-brand"
        : "text-gray-600 border-transparent hover:text-brand hover:border-gray-300"
    }`

  return (
    <nav className="border-b border-gray-200 bg-white">
      <div className="mx-auto max-w-7xl px-8">
        <div className="flex gap-8">
          <NavLink to="/admin/summary" end className={navLinkClasses}>
            Summary
          </NavLink>
          {isSuperAdmin ? (
            <NavLink to="/admin/organizations" className={navLinkClasses}>
              Organizations
            </NavLink>
          ) : null}
          <NavLink to="/admin/plans" className={navLinkClasses}>
            Dashboard
          </NavLink>
          {isSuperAdmin ? (
            <NavLink to="/admin/users" className={navLinkClasses}>
              Users
            </NavLink>
          ) : null}
          {isSuperAdmin ? (
            <NavLink to="/admin/faqs" className={navLinkClasses}>
              FAQs
            </NavLink>
          ) : null}
          <Link
            to="/plan"
            className="flex items-center gap-1.5 text-sm font-medium py-4 border-b-2 border-transparent text-gray-600 hover:text-brand hover:border-gray-300 transition-colors"
          >
            My Plans
            <i className="fa-solid fa-arrow-up-right-from-square text-xs"></i>
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default AdminNav
